import { render, staticRenderFns } from "./UpVacationForm.vue?vue&type=template&id=0b44faaa&"
import script from "./UpVacationForm.vue?vue&type=script&lang=js&"
export * from "./UpVacationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports